import { hashHistory } from 'react-router';

import { trackEventObject } from '../../../services/trackingService.js';

import {
    CREATE_AGREEMENT_START,
    CREATE_AGREEMENT_SUCCESS,
    CREATE_AGREEMENT_ERROR,
    NEW_AGREEMENT_DATA_RECEIVED,
} from './agreementActionTypes.js';
import { UPDATED_SAFE_TRADE_STATUS } from '../safeTradeActionTypes.js';
import mapResponse from '../../responseMapper.js';
import { post } from '../../../services/jsonfetchservice.js';

export function createAgreement({
    itemType,
    itemId,
    partnerId,
    amountOre: amount,
    freightOre: freight,
}) {
    trackEventObject({
        analyticsName: 'trade.make-agreement.buyer-sends-agreement',
        eventFlags: 'start',
        context: {
            finnkode: itemId,
        },
    });

    return dispatch => {
        dispatch({
            type: CREATE_AGREEMENT_START,
        });

        return post(`/safe-trade/${itemType}/${itemId}/${partnerId}.json`, {
            amount,
            freight,
        })
            .then(response => response.json())
            .then(data => mapResponse(data, partnerId, itemType, itemId))
            .then(mappedResponse => {
                dispatch({
                    type: NEW_AGREEMENT_DATA_RECEIVED,
                    payload: mappedResponse.agreement,
                });

                dispatch({
                    type: UPDATED_SAFE_TRADE_STATUS,
                    payload: mappedResponse.safeTrade.viewStatus,
                });

                dispatch({
                    type: CREATE_AGREEMENT_SUCCESS,
                });
                hashHistory.replace('/samtale');
            })
            .catch(() => {
                dispatch({
                    type: CREATE_AGREEMENT_ERROR,
                });
                hashHistory.replace('/avtale-feilet');
            });
    };
}



// WEBPACK FOOTER //
// ./safeTrade/buyer/agreement/agreementActions.js